import { siteAPIURL } from "@/utilities/constants";

interface PlanResultsResponse {
	catalogueProductsResponse?: any;
	nmiDetailResponse?: any;
	tarrifs?: string[];
	[key: string]: any;
}

export function getPlansbyNMI(nmi: string, promo?: string): PlanResultsResponse {
	console.log("getPlansbyNMID", nmi, promo);
	const url = new URL(siteAPIURL + "/signup/get-plans");
	url.searchParams.append("nmi", nmi);
	url.searchParams.append("energy", "electricity");
	if (promo) {
		url.searchParams.append("promo", promo);
	}

	return fetch(url)
		.then(response => response.json())
		.catch(error => {
			console.error("Failed to get plans", error);
			return {};
		});
}
